<h1>Supervision des batchs</h1>
<pannel [title]="'Filtres'" [expandable]="true" [folded]="true">
	<jobs-filters
		(filterRequest)="onFilterRequest($event)"
		>
	</jobs-filters>
</pannel>
<pannel [title]="'Batchs'">
	<jobs-table
		[filtersSubject]="filters$"
		>
	</jobs-table>
</pannel>